<template>
    <CurrentSearch
        :show="timeline.searching"
        :currentSearch="search.current"
        @clear="ClearSearch()"
    />
    <div id="timeline" :class="['flex', Classes().enabled]">
        <YBar
            :configurations="TIMELINE_CONFIGURATIONS"
            :prioritySelected="timeline.priority.selected"
            :enableConfigurations="timeline.configurations.enabled"
            @configure="SelectConfiguration($event)"
            @search="Search()"
        />
        <div id="content-detail" class="row">
            <OverlayNavigation
                v-if="CONFIG.timeline.navigation.useOverlayControls"
                :navigation="timeline.navigation"
                @navigate="Navigate($event)"
            />
            <Content
                v-if="ShowContent()"
                :years="timeline.years"
                :width="Width()"
                :distance="Distance()"
                :total="timeline.totalYears"
                :priority="timeline.priority"
                :timelineData="timeline.data"
                :yBarExpanded="yBarExpanded"
                :timelineZoom="zoom"
                :showZoomControl="timeline.configurations.showZoomControl"
                :totalDays="totalDays"
                :selectedProject="timeline.selectedProject"
                :enableYearLabelButtons="timeline.configurations.enabled"
                :searching="timeline.searching"
                @zoom="Zoom($event)"
                @project="$emit('project', $event)"
                @max-topography="SetTimelineProjectsMaxTopography($event)"
            />
        </div>

        <!-- Popups -->
        <Popup
            :popup="popup"
            @close="ClosePopup('Popup')"
            @view-project="ViewProject($event)"
            @set-search="SEARCH.Set(this, $event)"
            @save-search="SaveSearch()"
            @deselect-all-types="SEARCH.DeselectAllSearchTypes(this)"
        />
        <SimplePopup
            :popup="simplePopup"
            :showOverlay="true"
            @close="ClosePopup('Simple')">
            <div class="single">
                <p>Changes were made. Are you sure you want to close without applying them?</p>
                <Button
                    :type="BUTTON_TYPES.prominent"
                    value="Yes"
                    position="right"
                    @click="ForceClosePopup()"
                />
                <Button
                    :type="BUTTON_TYPES.off"
                    value="No"
                    position="right"
                    class="margin-tr"
                    @click="ClosePopup('Simple')"
                />
            </div>
        </SimplePopup>

    </div>
</template>

<script>
import Content from "@/components/Timeline/Content.vue";
import OverlayNavigation from "@/components/Timeline/Navigation/Overlay/Navigation.vue";
import YBar from "@/components/Timeline/YBar/YBar.vue";
import Popup from "@/components/Popups/Popup.vue";
import SimplePopup from "@/components/Popups/Simple.vue";
import Button from "@/components/Button.vue";
import CurrentSearch from "@/components/Projects/CurrentSearch/CurrentSearch.vue";
import { TIMELINE_CONFIGURATIONS } from "@/assets/JS/Assets.js";
import { CONFIG } from "@/assets/JS/Config.js";
import {
    ASSETS,
    BUTTON_TYPES,
    SEARCH
} from "@/assets/JS/Assets.js";
import { searchModel } from "@/models";
import $ from "jquery";

export default {
    name: "Timeline",
    props: { timeline: Object },
    components: {
        Content,
        OverlayNavigation,
        YBar,
        Popup,
        SimplePopup,
        Button,
        CurrentSearch
    },
    data: () => ({
        TIMELINE_CONFIGURATIONS,
        CONFIG,
        yBarExpanded: false,
        zoom: 0,
        totalDays: 0,
        popup: {},
        simplePopup: {},
        timelineProjectsMaxTopography: 0,
        ASSETS,
        ...searchModel.data,
        BUTTON_TYPES,
        SEARCH
    }),
    methods: {
        Width: function() {
            return `${((100 / this.timeline.totalYears) * this.zoom) + 100}%`;
        },
        Distance: function() { return `${this.timeline.distance}%`; },
        Navigate: function(navigation) {
            this.$emit("navigate", {
                navigation,
                width: this.Width(),
                totalYears: this.timeline.totalYears
            });
        },
        SelectConfiguration: function(configuration) {
            const { configurations } = this.timeline;
            switch(configuration.name) {
                case "Expand":
                case "Collapse":
                    this.yBarExpanded = !this.yBarExpanded;
                    break;
                case "Attach":
                    configurations.attached = true;
                    break;
                case "Detach":
                    configurations.attached = false;
                    break;
                case "Zoom":
                    configurations.showZoomControl = !configurations.showZoomControl;
                    break;
            }
            this.$emit("configure", this.timeline.configurations);
        },

        // Checks if timeline is defaulted to being attached and inverts attachments
        SetConfigurationAttachment: function() {
            let attach, detach;
            attach = {};
            detach = {};
            if (this.timeline.configurations.attached) {
                attach = this.TIMELINE_CONFIGURATIONS.detach;
                detach = this.TIMELINE_CONFIGURATIONS.attach;
            } else {
                attach = this.TIMELINE_CONFIGURATIONS.attach;
                detach = this.TIMELINE_CONFIGURATIONS.detach;
            }
            attach.show = true;
            detach.show = false;
        },

        Zoom: function(zoom) { this.zoom = zoom; },
        Classes: function() {
            return {
                enabled: this.timeline.configurations.enabled ? "timeline-enabled" : "timeline-disabled"
            };
        },
        ShowContent: function() {
            const { years, priority } = this.timeline;
            if (priority && priority.counts) {
                return years.length && Object.keys(priority.counts).length;
            }
            return years.length;
        },
        SetTimelineProjectsMaxTopography: function(maxTopography) {
            this.$emit("max-topography", maxTopography);
            this.timelineProjectsMaxTopography = maxTopography + 100;
        },
        ClosePopup: function(type) {
            if (type === "Popup") {
                if (!this.search.changeMade) {
                    this.popup = {};
                } else {
                    this.simplePopup = {
                        show: true,
                        title: "Change Made",
                        topography: this.timelineProjectsMaxTopography
                    };
                }
            } else { // Simple
                this.simplePopup = {};
            }
            $("body").css("overflow", "inherit");
        },
        ForceClosePopup: function() {
            this.search.changeMade = false;
            this.ClosePopup("Popup");
            this.ClosePopup("Simple");
        },

        // Search
        Search: function() {
            ASSETS.Projects.SetTypes(this, this.timeline.distinctProjectTypes);
            if (this.timeline.projectTypes) {
                this.popup = {
                    show: true,
                    title: "Search",
                    content: "Search",
                    topography: this.timelineProjectsMaxTopography,
                    search: this.search
                };
            }
            this.search.changeMade = false;
            $("body").css("overflow", "hidden");
        },
        SaveSearch: function() {

            // Set filters for projects
            const types = [];
            for (const type of this.search.types) {
                if (type.selected) {
                    types.push(type.value);
                }
            }
            this.search.current = { Types: types };

            // Setup additional project properties
            const { data, projectTypes } = this.timeline;
            for (const project of data) {
                project.ProjectTypes = projectTypes.filter(t => t.ProjectID === project.ProjectID);

                // Timeline coordinates
                project.TimelineCoordinates = {
                    YearIndex: project.CoordinateYearIndex,
                    MonthIndex: project.CoordinateMonthIndex,
                    X2: project.CoordinateX2,
                    Y1: project.CoordinateY1,
                    Y2: project.CoordinateY2,
                    TotalYears: project.CoordinateTotalYears,
                    DaysIntoYear: project.CoordinateDaysIntoYear,
                };

            }
            for (const project of data) {
                project.search = { types: [] };
                for (const projectType of project.ProjectTypes) {
                    if (types.indexOf(projectType.Name) !== -1) {
                        project.search.types = types;
                    }
                }
            }

            this.timeline.searching = types.length > 0;

            this.search.changeMade = false;
            this.ClosePopup("Popup");
        },
        ClearSearch: function() {
            SEARCH.DeselectAllSearchTypes(this);
            this.timeline.searching = false;
            this.search.current = {};
        }

    },
    beforeMount: function() {
        this.SetConfigurationAttachment();
        this.zoom = CONFIG.timeline.zoom.initial;
        const timelineHeight = ASSETS.Timeline.Height(CONFIG);
        this.totalDays = timelineHeight * this.timeline.totalYears;
        ASSETS.Projects.SetTypes(this, this.timeline.distinctProjectTypes);
        this.SaveSearch();
    },
    emits: [
        "navigate",
        "configure",
        "project",
        "hover-projects-content",
        "max-topography"
    ]
};
</script>